module.exports = {
	"config": {
		"siteTitle": "TCP Bros",
		"linkPrefix": "",
		"authors": {
			"miguelgondu@gmail.com": {
				"email": "miguelgondu@gmail.com",
				"name": "Miguel González Duque",
				"photo": "/bros/miguelgondu.jpeg"
			},
			"odarbelaeze@gmail.com": {
				"email": "odarbelaeze@gmail.com",
				"name": "Oscar David Arbeláez Echeverri",
				"photo": "/bros/odarbelaeze.jpeg"
			}
		}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ai",
				"base": "maquinas-que-juegan-ajedrez.md",
				"ext": "md",
				"name": "maquinas-que-juegan-ajedrez",
				"extname": ".md",
				"basename": "maquinas-que-juegan-ajedrez.md",
				"dirname": "ai",
				"stem": "maquinas-que-juegan-ajedrez",
				"path": "ai/maquinas-que-juegan-ajedrez.md"
			},
			"requirePath": "ai/maquinas-que-juegan-ajedrez.md",
			"path": "/ai/maquinas-que-juegan-ajedrez/",
			"data": {
				"title": "Máquinas que juegan juegos: ajedrez",
				"tags": "ajedrez, inteligencia artificial, autómatas",
				"summary": "Un resumen sobre máquinas que han jugado ajedrez a lo largo de la historia. Desde el Turco hasta Deep Blue.",
				"date": "2017-07-12T00:00:00.000Z",
				"author": "miguelgondu@gmail.com"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "git/branches",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "git/branches",
				"stem": "index",
				"path": "git/branches/index.md"
			},
			"requirePath": "git/branches/index.md",
			"path": "/git/branches/",
			"data": {
				"title": "Introducción a branches",
				"author": "miguelgondu@gmail.com",
				"date": "2017-03-03T00:00:00.000Z",
				"tags": "git, ramas, merge"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "git/commit",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "git/commit",
				"stem": "index",
				"path": "git/commit/index.md"
			},
			"requirePath": "git/commit/index.md",
			"path": "/git/commit/",
			"data": {
				"title": "Git Commit",
				"author": "odarbelaeze@gmail.com",
				"tags": "git, commit",
				"summary": "Explicamos cómo decidir cuando realizar un commit en un repositorio.",
				"date": "2017-07-03T00:00:00.000Z"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "git/intro",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "git/intro",
				"stem": "index",
				"path": "git/intro/index.md"
			},
			"requirePath": "git/intro/index.md",
			"path": "/git/intro/",
			"data": {
				"title": "Introducción y comandos locales",
				"author": "miguelgondu@gmail.com",
				"date": "2017-03-02T00:00:00.000Z",
				"tags": "git, intro"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "git/remotes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "git/remotes",
				"stem": "index",
				"path": "git/remotes/index.md"
			},
			"requirePath": "git/remotes/index.md",
			"path": "/git/remotes/",
			"data": {
				"title": "Repositorios remotos",
				"author": "odarbelaeze@gmail.com",
				"date": "2017-03-04T00:00:00.000Z",
				"tags": "git, remote, github, ramas, conflictos",
				"summary": "Explicamos cómo crear un repositorio remoto usando github, y cómo mantener los proyectos sinronizados en diferentes remotos."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "manifest.json",
				"ext": "json",
				"name": "manifest",
				"extname": ".json",
				"basename": "manifest.json",
				"dirname": "",
				"stem": "manifest",
				"path": "manifest.json"
			},
			"requirePath": "manifest.json",
			"path": "/manifest/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "node",
				"base": "node-version-manager.md",
				"ext": "md",
				"name": "node-version-manager",
				"extname": ".md",
				"basename": "node-version-manager.md",
				"dirname": "node",
				"stem": "node-version-manager",
				"path": "node/node-version-manager.md"
			},
			"requirePath": "node/node-version-manager.md",
			"path": "/node/node-version-manager/",
			"data": {
				"title": "Instalando node de manera segura",
				"author": "odarbelaeze@gmail.com",
				"tags": "node, js, cli",
				"summary": "Explicamos como instalar node de manera segura usando el gestor de versiones nvm (node version manager)",
				"date": "2017-07-10T00:00:00.000Z"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0